export default class AboutUs {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.about_us = {
      url: '',
      translations: [
        { id: null, heading: '', content: '', lang: 'ar' },
        { id: null, heading: '', content: '', lang: 'en' }
      ]
    }
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.about_us.url = data.url ? data.url : ''
      this.about_us.translations[0].id = itemAr ? itemAr.id : null
      this.about_us.translations[0].heading = itemAr ? itemAr.heading : ''
      this.about_us.translations[0].content = itemAr ? itemAr.content : ''
      this.about_us.translations[1].id = itemEn ? itemEn.id : null
      this.about_us.translations[1].heading = itemEn ? itemEn.heading : ''
      this.about_us.translations[1].content = itemEn ? itemEn.content : ''
    } else {
      this.setInitialValue()
    }
  }
}
